module.exports = __webpack_public_path__ + "img/bg-new.c1a41860.jpg";